import React from 'react';
import { PermissionEnum } from '../../../../../../core/enums/dictionariesEnums';
import {
  deletePricelistTimelineNoteThunk,
  editPricelistTimelineNoteThunk,
} from '../../../../../../store/thunks/pricelist/pricelistDetailsThunks';
import NoteEvent from '../../../../../../common/components/activity-events/note/NoteEvent';
import { BasicNoteEventProps } from '../../../../../../core/types/coreTypes';
import { useNoteActivityLog } from '../../../../../../common/hooks/useNoteActivityLog';

const PricelistNoteEvent: React.FC<BasicNoteEventProps> = ({ id, content = '', initiator = '' }) => {
  const {
    dispatch,
    value,
    setValue,
    isEditModal,
    isConfirmationModal,
    setIsConfirmationModal,
    closeHandle,
    menuItems,
  } = useNoteActivityLog(content);

  const editHandle = () => {
    id && dispatch(editPricelistTimelineNoteThunk({
      id,
      content: value.trim(),
      closeModal: closeHandle,
    }));
  };

  const deleteHandle = () => {
    id && dispatch(deletePricelistTimelineNoteThunk({
      id,
      closeModal: () => setIsConfirmationModal(false),
    }));
  };

  return (
    <NoteEvent
      content={content}
      menuItems={menuItems}
      value={value}
      setValue={setValue}
      isEditModal={isEditModal}
      closeEditModal={closeHandle}
      editHandle={editHandle}
      isConfirmationModal={isConfirmationModal}
      setIsConfirmationModal={setIsConfirmationModal}
      deleteHandle={deleteHandle}
      initiator={initiator}
      permission={PermissionEnum.PricelistEditDeleteNotesOfOtherUsersInActivityLog}
    />
  );
};

export default PricelistNoteEvent;
